
import { useEffect, useState } from "react"

import { useParams } from "react-router-dom";
import PropTypes from 'prop-types';
import { makeStyles } from 'tss-react/mui';
import { lighten, createTheme, ThemeProvider } from '@mui/material/styles';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TablePagination,
    TableRow, TableSortLabel, Toolbar, Typography, Paper, Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Link
} from '@mui/material';

import format from 'format-number'
import { esES } from "@mui/material/locale";
import PictureAsPdfTwoToneIcon from '@mui/icons-material/PictureAsPdfTwoTone';
import SolicitudParticular from "./SolicitudParticular";

const opcionesEstado = [{ id: 'registrada', label: 'Registrada' }, { id: 'autorizada', label: 'Autorizada' }, { id: 'ajustesJefe', label: 'Ajustes Jefe/Director' }, { id: 'ajustesAsistente', label: 'Ajustes Asistente' }, { id: 'firmaAutografa', label: 'En firma autógrafa' }, { id: 'enRevision', label: 'En revisión' }, { id: 'registrarGastos', label: 'Registrar gastos' }, { id: 'devolucionCaja', label: 'Devolución en caja' }, { id: 'concluida', label: 'Concluída' }, { id: 'cancelada', label: 'Cancelada' }, {id: 'atencionCSA', label: 'Atención en la sección de adquisiciones' }]
const estadoMap = opcionesEstado.reduce((acc, { id, label }) => {
    acc[id] = label;
    return acc;
  }, {});
function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const headCells = [
    { id: 'folio', numeric: false, disablePadding: false, label: 'Folio' },
    { id: 'estado', numeric: false, disablePadding: false, label: 'Estado' },
    
];


function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };
    return (
        <TableHead>
            <TableRow>

                {headCells.map((headCell) => (                    
                        <TableCell
                            key={headCell.id}
                            align={'right'}
                            padding={'normal'}
                            sortDirection={orderBy === headCell.id ? order : false}
                        >
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : 'asc'}
                                onClick={createSortHandler(headCell.id)}
                            >
                                {headCell.label}
                                {orderBy === headCell.id ? (
                                    <span className={classes.visuallyHidden}>
                                        {order === 'desc' ? '' : ''}
                                    </span>
                                ) : null}
                            </TableSortLabel>

                        </TableCell>                      
                    
                ))}
                <TableCell align="right">
                            Monto comprometido
                        </TableCell>
                        <TableCell align="right">
                            Monto ejercido
                        </TableCell>
                        <TableCell align="right">
                            Monto añadido
                        </TableCell>
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
    ability: PropTypes.object.isRequired,
};


const useToolbarStyles = makeStyles()((theme) => ({
    root: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    title: {
        flex: '1 1 100%',
    }
}));

const EnhancedTableToolbar = (props) => {
    const partida = props.partida
    const classes = useToolbarStyles();

    return (
        <Toolbar style={{ alignContent: "space-around" }}>
            <Typography className={classes.title} variant="h6" id="tableTitle" component="div" style={{ paddingRight: 20, width:'80%' }}>
                Listado de solicitudes de la partida {partida?partida.clave:''} {partida?partida.concepto:''}
            </Typography>
            
            <Typography className={classes.title} variant="subtitle1" id="tableTitle" component="div" style={{ paddingRight: 20, width:'20%' }}>
                Monto asignado:<br/> {partida?format({ prefix: '$' })(Number(partida.montoMaximo).toFixed(2)):''} 
                <br/>Monto disponible:<br/> {partida?format({ prefix: '$' })(Number(partida.montoDisponible).toFixed(2)):''}
                <br/><Button variant='contained' style={{ marginTop: 20, backgroundColor: "darkgreen", color: 'white', width: '100%' }} onClick={() => { window.open(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/informeProyecto/mostrarReporteCierre/${partida.idProyectoPlan}`) }}>Reporte Cierre Planeación <PictureAsPdfTwoToneIcon></PictureAsPdfTwoToneIcon></Button>
            </Typography>
            
        </Toolbar>
    );
};

EnhancedTableToolbar.propTypes = {
    partida: PropTypes.object.isRequired,
};

const theme = createTheme(esES);

const useStyles = makeStyles()((theme) => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
}));

export default function SolicitudesPartida() {
    const params = useParams()
    const idPartida = params.idPartida;
    const [solicitudes, setSolicitudes] = useState([])
    const [totalComprometido, setTotalComprometido] = useState(0)
    const [totalEjercido, setTotalEjercido] = useState(0)
    const [totalSumado, setTotalSumado] = useState(0)
    const [partida, setPartida] = useState(null)
    const [solicitud, setSolicitud] = useState(null)
    const [openSolicitud, setOpenSolicitud] = useState(null)

    const cargarDatosTabla = async () => {
        const resSolicitudes = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/porPartida/${idPartida}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        })

        const solicitudesLeidas = await resSolicitudes.json()
        //console.log(`solicitudesLeidas ${JSON.stringify(solicitudesLeidas)}`)
        setSolicitudes(solicitudesLeidas)
        let totalC=0
        let totalE=0
        let totalS=0
        solicitudesLeidas.map((solicitud) => {
            totalC=Number(Number(totalC)+Number(solicitud.montoComprometido?solicitud.montoComprometido:0))
            totalE=Number(Number(totalE)+Number(solicitud.montoEjercido?solicitud.montoEjercido:0))
            totalS=Number(Number(totalS)+Number(solicitud.montoSumado?solicitud.montoSumado:0))
        })  
        setTotalComprometido(totalC)
        setTotalEjercido(totalE)
        setTotalSumado(totalS)

    }



    useEffect(() => {
        (async () => {
            const resPartida = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/partidasProyecto/${idPartida}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": sessionStorage.getItem('token'),
                        "perfil": sessionStorage.getItem('perfil')
                    }
                })
                const partida = await resPartida.json()
                setPartida(partida)
            await cargarDatosTabla()
        })();
        // eslint-disable-next-line
    }, [idPartida]
    )

    const classes = useStyles();
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('folio');
    const [page, setPage] = useState(0);

    const [rowsPerPage, setRowsPerPage] = useState(10);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, solicitudes.length - page * rowsPerPage);

    return (
        <>
            {/*
        <div role="presentation" style={{marginTop:'20px'}} >
      <Breadcrumbs aria-label="breadcrumb">
        <Link
          underline="hover"
          sx={{ display: 'flex', alignItems: 'center' }}
          color="inherit"
          href={esJefe?'/':`/proyectosInforme/${idResponsable}`}
        >
          <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
          Home
        </Link>
        <Link
          underline="hover"
          sx={{ display: 'flex', alignItems: 'center' }}
          color="inherit"
          href="javascript:void(0)" onClick={()=>{navigate(-1)}}
        >
          <KeyboardBackspaceIcon sx={{ mr: 0.5 }} fontSize="inherit" />
          Regresar
        </Link>       
      </Breadcrumbs>
    </div>*/}
            <div className={classes.root} style={{ marginTop: 50 }}>

                <Paper className={classes.paper}>

                    <EnhancedTableToolbar partida={partida}/>
                    <TableContainer>
                        <Table
                            className={classes.table}
                            aria-labelledby="tableTitle"
                            size={'medium'}
                            aria-label="enhanced table"
                        >
                            <EnhancedTableHead
                                classes={classes}
                                order={order}
                                orderBy={orderBy}
                                onRequestSort={handleRequestSort}
                                rowCount={solicitudes.length}
                            />
                            <TableBody>

                                {stableSort(solicitudes, getComparator(order, orderBy))
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((row, index) => {

                                        const labelId = `enhanced-table-checkbox-${index}`;

                                        return (
                                            <TableRow
                                                hover
                                                tabIndex={-1}
                                                key={row.clave}
                                            >
                                                <TableCell align="right" component="th" id={labelId} scope="row" padding="normal" style={{ width: 20 }}>                                                   
                                                    <Link style={{ cursor: 'pointer' }} onClick={async () => { setSolicitud(row); setOpenSolicitud(true) }} >{row.folio}</Link>
                                                </TableCell>
                                                <TableCell align="right">{estadoMap[row.estado] || ''}</TableCell>
                                                <TableCell align="right">{isNaN(Number(row.montoComprometido)) ? '' : format({ prefix: '$' })(Number(row.montoComprometido).toFixed(2))}</TableCell>
                                                <TableCell align="right">{isNaN(Number(row.montoEjercido)) ? '' : format({ prefix: '$' })(Number(row.montoEjercido).toFixed(2))}</TableCell>
                                                <TableCell align="right">{isNaN(Number(row.montoSumado)) ? '' : format({ prefix: '$' })(Number(row.montoSumado).toFixed(2))}</TableCell>

                                            </TableRow>
                                            
                                        );
                                    })}
                                    <TableRow style={{backgroundColor:"#eee"}}>
                                                <TableCell align="right" component="th" padding="normal" style={{ width: 20 }}>
                                                    
                                                </TableCell>
                                                <TableCell align="right" style={{fontWeight:"bold"}}>Total</TableCell>
                                                <TableCell align="right" style={{fontWeight:"bold"}}>{isNaN(Number(totalComprometido)) ? '' : format({ prefix: '$' })(Number(totalComprometido).toFixed(2))}</TableCell>
                                                <TableCell align="right" style={{fontWeight:"bold"}}>{isNaN(Number(totalEjercido)) ? '' : format({ prefix: '$' })(Number(totalEjercido).toFixed(2))}</TableCell>
                                                <TableCell align="right" style={{fontWeight:"bold"}}>{isNaN(Number(totalSumado)) ? '' : format({ prefix: '$' })(Number(totalSumado).toFixed(2))}</TableCell>

                                            </TableRow>
                                {emptyRows > 0 && (
                                    <TableRow style={{ height: (53) * emptyRows }}>
                                        <TableCell colSpan={6} />
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <ThemeProvider theme={theme}>
                        <TablePagination
                            rowsPerPageOptions={[10, 20, 30]}
                            component="div"
                            count={solicitudes.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </ThemeProvider>
                </Paper>
                <Dialog open={openSolicitud} fullWidth={true}
                maxWidth='xl' >

                <DialogTitle>Detalles de la solicitud {solicitud ? solicitud.folio : ''}</DialogTitle>
                <DialogContent style={{ backgroundColor: '#FFFEED' }}>
                    {solicitud ? <SolicitudParticular id={solicitud.id}></SolicitudParticular>:<></>}
                </DialogContent>
                <DialogActions>
                    <Button variant='contained' style={{ backgroundColor: "darkgreen", color: 'white' }} onClick={() => { setOpenSolicitud(false) }}>Cerrar Ventana</Button>
                </DialogActions>

            </Dialog>
            </div>

        </>
    );
}